/**
 * Frontend error-klass matchande backend/lib/errors.js.
 * Components kan switch:a på `err.status` eller `err.code` för att visa
 * rätt felmeddelande (404 → "Hittades inte", 401 → redirect till login, etc.).
 */

export class HttpError extends Error {
  constructor(message, { status = 0, code = 'unknown', details = null, correlationId = null, cause = null } = {}) {
    super(message);
    this.name = 'HttpError';
    this.status = status;
    this.code = code;
    this.details = details;
    this.correlationId = correlationId;
    if (cause) this.cause = cause;
  }

  get isNotFound() { return this.status === 404; }
  get isUnauthorized() { return this.status === 401; }
  get isForbidden() { return this.status === 403; }
  get isValidation() { return this.status === 400; }
  get isConflict() { return this.status === 409; }
  get isRateLimited() { return this.status === 429; }
  get isServerError() { return this.status >= 500; }
  get isNetworkError() { return this.status === 0; }
}
